import type { FieldSpec } from "@medbillai/schemas";

// Field types the chat renderer (ActiveUserInput) can show an input for.
// Anything else falls back to free text: the composer stays open and the
// renderer reports it to Sentry.
const CHAT_RENDERABLE_FIELD_TYPES = new Set<FieldSpec["type"]>([
  "text",
  "money",
  "date",
  "select",
  "multiselect",
  "search",
  "boolean",
  "document",
  "group",
]);

export const isRenderableChatField = (type: FieldSpec["type"]): boolean =>
  CHAT_RENDERABLE_FIELD_TYPES.has(type);
